import { PassionateAboutItem } from "./types";

const passionateAbout: PassionateAboutItem[] = [
    {
        name: "Web Development",
    },
    {
        name: "Machine Learning - Data Mining",
    },
    {
        name: "Parallel Programming",
    },
];

export { passionateAbout };
